<template>
  <div align="left">
    <b-tabs vertical pills>
      <b-tab title="Single Precision"><single/></b-tab>
      <b-tab title="Double Precision"><double/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import single from '@/components/single'
import double from '@/components/double'
export default {
  name: 'integers',
  components: {
    single,
    double
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ieee754.vue